import { z } from "zod";

import { REQUIRED_MESSAGE } from "@/utils";

import { baseProductSchema } from "./base-product.schema";

export const groupLifeSchema = baseProductSchema
  .omit({ min_permitted_age: true, max_permitted_age: true })
  .extend({
    // Campos de idade obrigatórios para VG
    min_permitted_age: z
      .preprocess(
        (v) =>
          v === "" || v === null || v === undefined ? undefined : Number(v),
        z.number().min(0, { message: REQUIRED_MESSAGE })
      )
      .refine((val) => val !== undefined && val !== null, {
        message: REQUIRED_MESSAGE,
      }),
    max_permitted_age: z
      .preprocess(
        (v) =>
          v === "" || v === null || v === undefined ? undefined : Number(v),
        z.number().min(0, { message: REQUIRED_MESSAGE })
      )
      .refine((val) => val !== undefined && val !== null, {
        message: REQUIRED_MESSAGE,
      }),
  policy_holder: z.string().optional().nullable(),
  code_plan: z.string().optional().nullable(),

  coverage_death_natural_causes: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_death_accident: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_total_disability: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_partial_disability: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_medical_expenses: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),

  benefit_24h_coverage: z.boolean().optional(),
  benefit_worldwide_coverage: z.boolean().optional(),
  benefit_occupational_coverage: z.boolean().optional(),
  benefit_non_occupational_coverage: z.boolean().optional(),
  benefit_waiver_premium: z.boolean().optional(),

  minimum_group_size: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().min(1).optional()
    )
    .optional(),
  maximum_group_size: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().min(1).optional()
    )
    .optional(),
  group_discount_percentage: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().min(0).max(100).optional()
    )
    .optional(),
});

export type TGroupLifeFormData = z.infer<typeof groupLifeSchema>;
